// === Quantity Limit Config ===
// Restaurant → Variant → Min Qty
// Custom Developed by : EIT Team

console.log("%cCONFIG FILE LOADED 🟢", "font-size:16px;color:#00ff00");

// ============ PUT ALL RESTAURANTS + VARIANTS HERE ============ //
window.QTY_LIMITER_RESTAURANTS = {
    "783": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "820": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
      "784": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
      "785": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
      "786": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "787": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "887": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "1247": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "788": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "791": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "790": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "792": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "793": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "794": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
      "890": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "2389": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    }, 
    "796": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "797": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "798": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "799": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "801": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "800": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "802": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "803": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "804": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "805": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    }, 
    "806": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "807": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    }, 
    "811": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "812": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "808": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "809": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "810": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "813": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "888": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "814": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "782": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
       45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "816": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "817": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "818": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    },
    "819": {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
    } // END of "819"

};  // ← END THE RESTAURANTS MASTER OBJECT PROPERLY

  // Global fallback (PDP uses this)
  window.DATE_BASED_QTY_LIMITS = {
      48207986983189: 5,  // Crispy Pork with Peanut Sauce
      47946905288981: 5,  // Batangas Pork Adobo
      47550095753493: 5,  // Soy Chicken Rice Bowl
      47550075568405: 5,  // Glazeed Salmon Rice Bowl
      48785001087253: 5,  // Double Chocolate Champorado
      48785002692885: 5,  // Breakfast Platter Sausage
      48786252628245: 5,  // Breakfast Platter - Extra Strawberry Jam
      48786252857621: 5,  // Breakfast Platte - Extra Hasbrown
      46323273138453: 5,  // Biscoff French Toast 
      45317885591829: 5,  // Homemade Beef Tapa Strips
      46384590848277: 5,  // Bacon Bagnet
      45317885657365: 5,  // Daing na Bangus
      45317885559061: 5,  // Mom's Garlic Longganisa
      45401375506709: 5,  // Pork Tocino
      45442239922453: 5,  // Smoked Boneless Bangus
      45400083726613: 5,  // Chef's Special Plate (Breakfast Medley)
      45400825168149: 5,  // Perfect Filipino Plate (Breakfast Medley)
      45401482690837: 5,  // Really Meaty Plate (Breakfast Medley)
      47931490566421: 5,  // Buffalo Wings
      45746449776917: 5,  // Chicken Lollies
      45317885329685: 5,  // Gambas y Champiñon al Ajillo
      45746097553685: 5,  // Salt & Pepper Calamari
      45317884674325: 5,  // Mango Royale Salad
      45317885002005: 5,  // Chicken Potato Salad 
      45317884936469: 5,  // Conti's Signature Salad
      45317884805397: 5,  // Homemade Caesar Salad
      45317884608789: 5,  // Pineapple Macaroni Salad
      45317884510485: 5,  // Symphony Salad
      49402685817109: 5,  // Boneless Chicken Inasal
      49402692731157: 5,  // Sizzling Mango Bulalo
      49402687357205: 5,  // Mango Bulalo
      45317884281109: 5,  // Conti's Baked Salmon
      46414446952725: 5,  // Baked Prawns
      45317884150037: 5,  // Salmon Salpicao
      45317883887893: 5,  // Chicken Ala Kiev
      46448102015253: 5,  // Chicken Barbeque - Java Rice
      46448102048021: 5,  // Chicken Barbeque - Steamed Rice
      46448102080789: 5,  // Chicken Barbeque - Garlic Rice
      46448129474837: 5,  // Barbequed Spare Ribs - Java Rice
      46448129507605: 5,  // Barbequed Spare Ribs - Steamed Rice
      46448129540373: 5,  // Barbequed Spare Ribs - Garlic Rice
      46414466416917: 5,  // Roast Beef in Mushroom Sauce - Mashed Potato
      46414466449685: 5,  // Roast Beef in Mushroom Sauce - Garlic Rice
      45317883560213: 5,  // Beef Salpicao - Garlic Rice
      45317883592981: 5,  // Beef Salpicao - Paella Rice
      45317883494677: 5,  // Lengua Estofado
      49089229324565: 5,  // Bacon Mac n Cheese
      49089225163029: 5,  // Cheesy Spaghettimelt
      46355656245525: 5,  //Truffle Mushroom Linguine
      45317882478869: 5, // Cheesy Baked Macaroni
      45317882413333: 5, // Lasagna
      45317882380565: 5, // Linguine in Pesto Sauce
      45317882347797: 5, // Linguine in Pesto Sauce with Seafood
      45317882282261: 5, // Pasta Carbonara
      45317881069845: 5, // Pasta con Gambas
      46414512029973: 5, // Vongole Bianco
      45317880152341: 5, // Fresh Lumpiang Ubod (2 pcs)
      45746726928661: 5, // Tofu Steak with Japanese Rice
      45746492932373: 5, // Hearty Cowder
      48520445985045: 5, // Creamy Tomato Soup
      45317880086805: 5, // Molo Soup
      45317880217877: 5, // Hearty Club Sandwich
      45317880348949: 5, // Chicken Salad Sandwich
      45317880119573: 5, // Garlic Sotanghon
      45317880054037: 5, // Pancit Palabok
      48871612711189: 5, // Burnt Mais con Crema
      48073738879253: 5, // Ube Custard Halo-halo
      45317878743317: 5, // Halo-Halo Special - Regular
      45317878776085: 5, // Halo-Halo Special - Junior (for Dine-in Only)
      46412752519445: 5, // Mango Bravo Slice
      45683222020373: 5, // Freshly Brewed Bottled Iced Tea (500ml)
      45317878907157: 5, // Bottled Water
      45317878841621: 5, // Coke in Can (Original)
      45317878808853: 5, // Coke Zero in Can
      45317883527445: 5, // Callos
      45317878677781: 5 // Sprite in Can
};


/* =========================================================
   RESTRICTED DATES
========================================================= */
window.RESTRICTED_DATES = ["2025-12-23", "2025-12-30"];


/* =========================================================
   FINAL CONFIG OBJECT — THIS MUST BE LAST
========================================================= */
window.QTY_LIMITER_CONFIG = {
  restaurants: window.QTY_LIMITER_RESTAURANTS,
  fallback: window.DATE_BASED_QTY_LIMITS,
  restrictedDates: window.RESTRICTED_DATES
};

console.log("%c[QtyLimiter CONFIG READY]","color:#0F0;font-weight:bold", window.QTY_LIMITER_CONFIG);